import React from 'react'

export default function Modal({ title, body, button, showModal, setShowModal, onSubmit }) {
    if (!showModal) return null

    return (
        <>
            <div className="modal-backdrop fade show" onClick={() => setShowModal(false)}></div>
            <div
                className="modal fade show"
                style={{ display: "block" }}
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                onClick={() => setShowModal(false)}
            >
                <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">{title}</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className="modal-body">
                            {body}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                                {button.close}
                            </button>
                            <button type="button" className="btn btn-primary" onClick={onSubmit}>
                                {button.valid}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}